/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
const Privacy = () => {
  const handleClick = () => {
    window.location.href = "/";
  };

  return (
    <>
      {/* saved from url=(0051)https://getbootstrap.com/docs/4.0/examples/pricing/ */}
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      {/* Meta Title */}
      <title>
        Norton Antivirus Activation &amp; Support | Redeem Product Key &amp;
        Contact Support
      </title>
      {/* Meta Description */}
      <meta
        name="description"
        content="Redeem your Norton Antivirus product key and activate your protection today! Need help? Our support team is available to assist with any issues or questions you may have."
      />
      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="Norton Antivirus, redeem product key, activate Norton, Norton support, antivirus activation, product key support, contact Norton support, Norton customer service"
      />
      {/* Meta Robots */}
      <meta name="robots" content="index, follow" />
      {/* Open Graph Meta Tags (for social media sharing) */}
      <meta
        property="og:title"
        content="Norton Antivirus - Redeem & Activate Product Key"
      />
      <meta
        property="og:description"
        content="Easily redeem and activate your Norton Antivirus product key. Our support team is here to assist with any activation issues or technical inquiries."
      />
      <meta property="og:image" content="" />
      <meta property="og:url" content="www.pcscancare.com" />
      <meta property="og:type" content="website" />
      {/* Twitter Card Meta Tags (for Twitter sharing) */}
      <meta
        name="twitter:title"
        content="Norton Antivirus - Activate Your Product Key & Get Support"
      />
      <meta
        name="twitter:description"
        content="Redeem your Norton Antivirus product key, activate your protection, and reach out to our support team for any help or troubleshooting needs."
      />
      <meta name="twitter:image" content="" />
      <meta name="twitter:card" content="summary_large_image" />
      {/* Canonical Link */}
      <link rel="canonical" href="www.pcscancare.com" />
      <link rel="icon" href="./assets/img/nlok.ico" />
      {/* Bootstrap core CSS */}
      <link href="./assets/bootstrap.min.css" rel="stylesheet" />
      {/* Custom styles for this template */}
      <link href="./assets/form.css" rel="stylesheet" />
      <div className="header-section border-bottom box-shadow">
        <div className="container">
          <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 bg-white ">
            <h5 className="my-0 mr-md-auto font-weight-normal">
              <img src="/main-logo.svg" alt="Main logo" onClick={handleClick} />
            </h5>
            <nav className="my-2 my-md-0 mr-md-3">
              <Link className="p-2 text-dark" to="/privacy">
                Privacy Policy
              </Link>
              <Link className="p-2 text-dark" to="/terms">
                Terms &amp; Conditions
              </Link>
              <span className="p-2 text-dark">
                <strong>Contact US: +1 (805) 222-0570 </strong>
              </span>
            </nav>
          </div>
        </div>
      </div>
      <div className="main">
        <header
          style={{
            background: "#242e39",
            color: "white",
            padding: "100px 0",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h1>Privacy Policy</h1>
                <div
                  style={{
                    background: "yellow",
                    width: 100,
                    height: 3,
                    marginTop: 20,
                  }}
                />
              </div>
            </div>
          </div>
        </header>
        <div className="container">
          <div className="row">
            <main>
              <section className="mt-4">
                <h4>Introduction</h4>
                <p>
                  Welcome to the Norton Antivirus Setup Guide PcScanCare. This
                  privacy policy outlines how we collect, use, and protect your
                  personal information when you visit and use our website. By
                  using our website, you agree to the terms of this privacy
                  policy.
                </p>
              </section>
              <section className="mt-4">
                <h4>Information We Collect</h4>
                <p>
                  We collect personal information only when you voluntarily
                  provide it to us. This may include, but is not limited to:
                </p>
                <ul>
                  <li>Your name</li>
                  <li>Your email address</li>
                  <li>Device and browser information</li>
                  <li>
                    Usage data such as pages visited and time spent on our site
                  </li>
                </ul>
              </section>
              <section className="mt-4">
                <h4>How We Use Your Information</h4>
                <p>
                  The information we collect is used for the following purposes:
                </p>
                <ul>
                  <li>To improve the user experience on our website.</li>
                  <li>To provide support and respond to your inquiries.</li>
                  <li>
                    To send you relevant updates, news, and offers related to
                    Norton Antivirus and our setup guide.
                  </li>
                  <li>
                    To monitor and analyze website traffic and usage patterns.
                  </li>
                </ul>
              </section>
              <section className="mt-4">
                <h4>Cookies</h4>
                <p>
                  We use cookies to enhance your experience on our website.
                  Cookies are small files that are stored on your device. They
                  help us understand how you interact with our website, which
                  allows us to improve content and functionality. You can adjust
                  your browser settings to reject cookies if you prefer, but
                  some features of our website may not function as expected
                  without them.
                </p>
              </section>
              <section className="mt-4">
                <h4>Third-Party Services</h4>
                <p>
                  We may use third-party services (such as analytics tools) to
                  help us analyze website traffic and improve our site. These
                  third-party services may collect information about your visits
                  to our website, but they are subject to their own privacy
                  policies. We do not control these third-party services, and we
                  recommend reviewing their privacy policies for more
                  information.
                </p>
              </section>
              <section className="mt-4">
                <h4>Data Security</h4>
                <p>
                  We take reasonable measures to protect the personal
                  information you provide through our website. However, no
                  method of data transmission over the internet is completely
                  secure, and we cannot guarantee the security of your
                  information. By using our site, you acknowledge and accept
                  these risks.
                </p>
              </section>
              <section className="mt-4">
                <h4>Your Rights</h4>
                <p>
                  You have the right to access, correct, or delete your personal
                  information. If you would like to update or remove your data,
                  please contact us through our contact form or at our provided
                  contact email.
                </p>
              </section>
              <section className="mt-4">
                <h4>Changes to This Privacy Policy</h4>
                <p>
                  We may update this privacy policy from time to time to reflect
                  changes in our practices or legal requirements. Any updates
                  will be posted on this page, and the "Last Updated" date will
                  be revised accordingly.
                </p>
              </section>
              <section className="mt-4">
                <h4>Contact Us</h4>
                <p>
                  If you have any questions or concerns regarding this privacy
                  policy or our data practices, please feel free to contact us:
                </p>
                <p>
                  Email:{" "}
                  <a href="mailto:support@pcscancare.com">
                    support@pcscancare.com
                  </a>
                </p>
                <p>
                  Address: Norton Antivirus Setup Guide, 123 Cyber Street, Tech
                  City, 10001
                </p>
              </section>
            </main>
          </div>
        </div>
        <div className="container py-5 mt-4 border-top">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/tech.svg" alt="tech" />
                <div className="text-center mt-3">
                  <h5>
                    Technology blocks thousands
                    <br /> of threats every minute.
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/exp.svg" alt="Exp" />
                <div className="text-center mt-3">
                  <h5>
                    Count on decades of experience
                    <br /> and a proven track record
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/pro.svg" alt="pro" />
                <div className="text-center mt-3">
                  <h5>
                    Get the protection you and your
                    <br /> family need in one place.
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/award3.svg" alt="award3" />
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/award2.svg" alt="award2" />
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/award1.svg" alt="award1" />
              </div>
            </div>
          </div>
        </div>
        <footer className="py-4 border-top">
          <div className="container d-flex justify-content-between align-items-center">
            <p style={{ fontSize: 12 }}>
              Copyright © 2024 Gen Digital Inc. All rights reserved.
            </p>
            <img src="/main-logo.svg" alt="Main logo" />
          </div>
        </footer>
      </div>
      {/* Bootstrap core JavaScript
    ================================================== */}
      {/* Placed at the end of the document so the pages load faster */}
      <grammarly-desktop-integration data-grammarly-shadow-root="true">
        <template shadowrootmode="open" />
      </grammarly-desktop-integration>
    </>
  );
};

export default Privacy;
